import { isOrganizationalUnitSegmentationEnabled } from "@caredna-marlin/utils/featureFlags";
import { Permission } from "@caredna-marlin/utils/userRoles";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useCurrentOrg } from "~/providers/GraphqlProvider"

export { Permission as Permission };

export const useGetAssignedPermissions = () => {
  const currentOrg = useCurrentOrg();

  const assignedPermissions = new Set((currentOrg?.perms || []) as unknown as Permission[]);

  if (!currentOrg) { return undefined; }
  return assignedPermissions;
}

export const useHasPermission = (requestedPermission?: Permission) => {
  const assignedPermissions = useGetAssignedPermissions();
  return requestedPermission ? assignedPermissions?.has(requestedPermission) : undefined;
}

export const useHasAnyPermission = (requestedPermissions?: Permission[]) => {
  const assignedPermissions = useGetAssignedPermissions();
  return requestedPermissions ? requestedPermissions.some(p => assignedPermissions?.has(p)) : undefined;
}

export const useHasAllPermissions = (requestedPermissions?: Permission[]) => {
  const assignedPermissions = useGetAssignedPermissions();
  return requestedPermissions ? requestedPermissions.every(p => assignedPermissions?.has(p)) : undefined;
}

export const useOrganizationalUnitSegmentationEnabled = () => {
  return isOrganizationalUnitSegmentationEnabled(useCurrentOrg()?.perms);
}

// Unceremoniously dump the user back at the command center or some other URL if they lack a permission.
export const usePermissionOrRedirect = (permission: Permission, redirectTo: string = "/command") => {
  const navigate = useNavigate();
  const hasPermission = useHasPermission(permission);
  useEffect(() => {
    if (!hasPermission) {
      navigate(redirectTo);
    }
  }, [hasPermission]);
}
